import { useState } from "react";
import { Box, Typography } from "@mui/material";

export type EntityImageFolder = "clients" | "box" | "closet" | "manhole";

interface EntityImageProps {
  apiBaseUrl: string;
  folder: EntityImageFolder;
  filename: string;
  alt: string;
}

/**
 * Lazy-loaded map entity photo with bounded decode size and error fallback
 * (avoids huge images stalling the main thread).
 */
const EntityImage: React.FC<EntityImageProps> = ({
  apiBaseUrl,
  folder,
  filename,
  alt,
}) => {
  const [failed, setFailed] = useState(false);
  const src = `${apiBaseUrl}/public/${folder}/${filename}`;

  if (failed) {
    return (
      <Box sx={{ p: 1, bgcolor: "grey.200", borderRadius: 1, minHeight: 48 }}>
        <Typography variant="caption" color="text.secondary">
          Сликата не може да се вчита
        </Typography>
      </Box>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      decoding="async"
      onClick={() => window.open(src, "_blank", "noopener,noreferrer")}
      onError={() => setFailed(true)}
      style={{
        width: "100%",
        maxHeight: 280,
        objectFit: "contain",
        borderRadius: "8px",
        cursor: "pointer",
      }}
    />
  );
};

export default EntityImage;
